import type { ComparisonAccount } from './comparisonTypes';

export const isComparisonContentLoading = (
  accounts: ComparisonAccount[],
): boolean =>
  accounts.some((a) => a.contentLoading && !a.content);

export const isComparisonHistoryPending = (
  accounts: ComparisonAccount[],
): boolean =>
  accounts.some(
    (a) =>
      a.historyLoading ||
      (Boolean(a.content) && !a.history && !a.historyError),
  );

export const isComparisonDataLoading = (
  accounts: ComparisonAccount[],
): boolean =>
  isComparisonContentLoading(accounts) ||
  isComparisonHistoryPending(accounts);

export const comparisonLoadingProgress = (
  accounts: ComparisonAccount[],
): { contentLoaded: number; historyLoaded: number; total: number } => {
  const total = accounts.length;
  return {
    total,
    contentLoaded: accounts.filter((a) => a.content).length,
    historyLoaded: accounts.filter((a) => a.history).length,
  };
};

export const comparisonLoadingMessage = (
  accounts: ComparisonAccount[],
): string => {
  const { total, contentLoaded, historyLoaded } =
    comparisonLoadingProgress(accounts);

  if (isComparisonContentLoading(accounts)) {
    return `Loading portfolio details (${contentLoaded}/${total})…`;
  }
  if (isComparisonHistoryPending(accounts)) {
    return `Loading performance history (${historyLoaded}/${total})…`;
  }
  return 'Loading comparison data…';
};
